import React, { Component } from 'react'
import { connect } from "react-redux";
import classnames from "classnames";
import { get } from 'lodash'

import Button from './shared/Button';
import TooltipSubjects from './shared/TooltipSubjects';
import Radiobutton from './shared/Radiobutton';
import { trackValues } from './../tracker';
import { trackSiteId } from './../config';

import { SUBJECTS1, SUBJECTS2, SUB_SUBJECT } from './../constants/subjectTypes';
import { profileUpdateStages } from '../store/profile/actions'
import baseStyles from 'custom/base.styl';
import gridStyles from './../styles/grid.styl';

class PageMajorSubjects extends Component {
  constructor(props) {
    super(props)

    this.state = {
      idSubject: null,
      data: {
        major_subjects: [],
      }
    }

    this.onChange = this.onChange.bind(this);
    this.onClickRadio = this.onClickRadio.bind(this);
    this.renderElement = this.renderElement.bind(this);
    this._handleOnClickUpdateStages = this._handleOnClickUpdateStages.bind(this);
  }

  onClickRadio(e) {
    const { value } = e.target;
    const { idSubject } = this.state;

    this.setState({
      idSubject: !idSubject ? value : null,
    });
  }

  onChange(e) {
    const { name, value } = e.target;

    this.setState({
      idSubject: value,
      data: {
        [name]: [value],
      },
    });
  }

  renderItem(s, positionRight) {
    const { data, idSubject } = this.state;
    const checked = data.major_subjects && data.major_subjects.indexOf(s) > -1;

    return (
      <div>
        <Radiobutton
          id={s}
          value={s}
          name="major_subjects"
          checked={checked}
          onChange={this.onChange}
          onClick={this.onClickRadio}
          className={classnames(baseStyles.block, baseStyles.space_bottom)}
        >
          {s}
        </Radiobutton>
        {idSubject === s &&
          <ul className={classnames(baseStyles.tooltip_box_mobile, { [baseStyles.active]: checked })}>
            {SUB_SUBJECT[s].map(s => <li key={s}>{s}</li>)}
          </ul>
        }
      </div>
    )
  }

  _handleOnClickUpdateStages() {
    const { profileAppForm, profileStage, version, userId } = this.props;
    const { data } = this.state;
    const preferredSubject = data.major_subjects.join('');
    const trackData = { userId, version, site_id: trackSiteId, preferredSubject }

    trackValues('stage', profileStage, {
      context: trackData,
    });
    this.props.profileUpdateStages({ ...profileAppForm, ...data })
  }

  renderElement(s, positionLeft = false, positionRight = false) {
    return (
      <TooltipSubjects
        key={s}
        containerClass={classnames(baseStyles.tooltip_box, baseStyles.tooltip_subjects, { [baseStyles.tooltip_subjects_right]: positionRight })}
        contentClass={baseStyles.tooltip_subjects_content}
        renderContent={() => this.renderItem(s, positionRight)}
        positionLeft={positionLeft}
        positionRight={positionRight}
        bottom={positionRight}
      >
        <ul>
          {SUB_SUBJECT[s].map(s => <li key={s}>{s}</li>)}
        </ul>
      </TooltipSubjects>
    );
  }

  render() {
    if (this.props.isFetching) return null;
    const { data } = this.state;
    const isDisabledButton = data.major_subjects && !data.major_subjects.length;
    return (
      <div>
        <div className={baseStyles.header}>
          <h2 className={baseStyles.title}>Application form!</h2>
        </div>
        <p className={baseStyles.subtitle_type2}>We use this information to recommend you orders in your preferred subjects</p>

        <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.content_wide)}>
          <div className={baseStyles.subtitle_type3}>Choose one subject category that you feel passionate <br /> about and would primarily like to focus on:</div>
          <div className={baseStyles.subtitle_type2}>On the next stage you will be able to choose <b className={baseStyles.text_success}>two more subject categories</b> from the same list.</div>

          <div className={classnames(gridStyles.row, baseStyles.space_bottom_large, baseStyles.xs_block)}>
            <div className={classnames(gridStyles.col_6, baseStyles.left)}>
              {SUBJECTS1.map(s => this.renderElement(s, true))}
            </div>
            <div className={classnames(gridStyles.col_6, baseStyles.left)}>
              {SUBJECTS2.map(s => this.renderElement(s, false, true))}
            </div>
          </div>
          <Button disabled={isDisabledButton || this.props.isFetching} onClick={this._handleOnClickUpdateStages}>Continue</Button>
        </div>
      </div>
    )
  }
};

const mapStateToProps = state => {
  const profile = state.profile;
  const isFetching = (profile && profile.isFetching) || false;
  const profileAppForm = get(profile.data, 'user.profile.applicant_info');

  const userId = get(profile.data, 'user.id');
  const profileStage = get(profile.data, 'user.stage');
  const version = get(profile.data, 'user.scenario_version');
  const subjectType = get(profile.data, 'user.profile.subject_type');

  return {
    profileAppForm,
    isFetching,
    profileStage,
    version,
    subjectType,
    userId,
  }
};

const mapDispatchToprops = dispatch => ({
  profileUpdateStages: (data) => (dispatch(profileUpdateStages(data))),
});

export default connect(mapStateToProps, mapDispatchToprops)(PageMajorSubjects);



// WEBPACK FOOTER //
// ./src/components/PageMajorSubjects.js